import React from 'react';
import { css } from '@emotion/react';
import { LoadingOutlined } from '@ant-design/icons';

const AXALoginButton = ({
  onClick,
  label,
  isLoading
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { label?: string; isLoading: boolean }) => {
  return (
    <button
      css={css`
        border-radius: 4px;
        height: 2.75em;
        width: 100%;
        border: 0;
        color: #fff !important;
        font-size: 1rem;
        background-color: #00008f;

        :hover:enabled,
        :focus,
        :active {
          background-color: #0000c2 !important;
          color: #fff !important;
          cursor: pointer;
        }
      `}
      data-testid="axa-login-button"
      onClick={onClick}
    >
      {label || 'AXA Health Log In'}
      {isLoading ? <LoadingOutlined aria-hidden="true" /> : ''}
    </button>
  );
};

export default AXALoginButton;
